import { render, staticRenderFns } from "./ProgramQuery.vue?vue&type=template&id=d06dfae6"
import script from "./ProgramQuery.vue?vue&type=script&lang=ts"
export * from "./ProgramQuery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports